import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import type { SiffletColors } from '@/plugins/theme';
import { type IconSize } from '@/components/SIcon.vue';
/**
 *
 * Display a simple & unobtrusive information tag, with icon and label
 *
 */

export type SChipSize = IconSize

interface SChipBasicProps {
  icon?: string | null;
  size?: SChipSize;
  text: string;
  color?: SiffletColors;
  textColor?: SiffletColors;
  iconAlignment?: 'left' | 'right';
  shouldTruncate?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SChipBasic',
  props: {
  icon: null,
  size: { default: 'default' },
  text: null,
  color: { default: 'iconNeutral' },
  textColor: null,
  iconAlignment: { default: 'left' },
  shouldTruncate: { type: Boolean }
},
  setup(__props) {

const props = __props;


const iconColor = _computed(() => props.color);
const textColor = _computed(() => props.textColor || props.color);
const fontSize = _computed(() => {
  switch (props.size) {
    case 'x-small':
      return 'text-x-small';
    case 'small':
      return 'text-caption';
    case 'default':
      return 'text-body-2';
    case 'large':
      return 'text-body-1';
    default:
      return 'text-body-2';
  }
});
const truncate = _computed(() => (props.shouldTruncate ? 'text-truncate' : ''));

return { __sfc: true,props, iconColor, textColor, fontSize, truncate, _computed }
}

})